
import CustomImage from "components/common/CustomImage";
export default function GuideQuickTips(props: { className ?: string, onCancel: () => void}){
    const { className = '', onCancel } = props ;
    return (
        <div className={`absolute bg-[#FFFFFF] w-[571px] z-[999999] rounded-[10px] px-[30px] py-[20px] xl:py-[30px] ${className || 'left-[50%] top-[50%]  translate-x-[-50%] translate-y-[-50%]'}`}>
            <div className="flex items-center justify-center gap-[10px]">
                <CustomImage src="/icon/icon-guide-hand.png" className="w-[30px]"/>
                <p className="font-bold text-[20px]">Welcome to Mockuplabs.ai</p>
            </div>
            <CustomImage src="/icon/icon-close.png" className="absolute right-[30px] top-[20px] xl:top-[30px] w-[30px] cursor-pointer" 
                    onClick={onCancel}/>
            <div className="small-txt mt-[20px]">
                <p className="font-semibold">⭐ To design a mockup, upload at least two images:</p>
                <ul className="list-decimal ml-[20px]">
                    <li className="mt-[10px]">Upload a product image and click "Mockup" to generate the mockup.</li>
                    <li className="mt-[10px]">Upload a design image and drag it into the mockup for editing and design.</li>
                    <li className="mt-[10px]">Click "Download" to obtain the high-quality design mockup.</li>
                </ul>

                <p className="mt-[10px] xl:mt-[20px] font-semibold">For example:</p>
                <div className="flex items-center mt-[15px]">
                    <div>
                        <div className="mr-[5px] rounded-[10px] text-center border h-[164px]">
                            <CustomImage src="/case/introduction-1.png" className="w-[135px] rounded-t-[10px]" />
                            <span className="my-[3px] block">Product Image</span>
                        </div>
                    </div>
                    <div>
                        <div className="ml-[5px] rounded-[10px] text-center border h-[164px]">
                            <CustomImage src="/case/introduction-2.png" className="w-[135px] rounded-t-[10px]" />
                            <span className="my-[3px] block">Design image</span>
                        </div>
                    </div>
                    <div className="grow flex justify-center">
                        <CustomImage src="/icon/icon-guide-right.png" className="w-[48px] rounded-t-[10px]" />
                    </div>
                    <div >
                        <div className="rounded-[10px] text-center border h-[164px]">
                            <CustomImage src="/case/introduction-3.png" className="w-[135px] rounded-t-[10px]" />
                            <span className="my-[3px] block">Mockup</span>
                        </div>
                    </div>
                </div>
                <span className="text-[#7B7B7B] text-[10px] xl:text-[12px] mt-[20px] block">If you don't have the required images at the moment, you can click on the "Project" tutorial and follow the steps to edit the sample images on the canvas.</span>
            </div>
        </div>
    )
}